import { Button, Stack, Typography } from '@common-components';
import { messages } from 'i18n';
import { Market } from 'types';

interface WorkingOnBannerProps {
  selectedMarket: Market | null;
  onSwitchCarrier: () => void;
}

export default function WorkingOnBanner({ selectedMarket, onSwitchCarrier }: WorkingOnBannerProps) {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center" gap={2}>
      {selectedMarket ? (
        <Stack direction="row" gap={0.5}>
          <Typography variant="body2">{messages.submissionQueuePage.workingOn}</Typography>
          <Typography variant="body2Bold">{selectedMarket.organizationName}</Typography>
        </Stack>
      ) : (
        <Typography variant="body2">{messages.general.loading}</Typography>
      )}
      <Button variant="outlined" onClick={onSwitchCarrier} size="small">
        {messages.submissionQueuePage.switchCarrier}
      </Button>
    </Stack>
  );
}
